import React, { useContext, useEffect, useState } from "react";
import axios from "../../../../Axios/Axios";
import { Urls } from "../../../../Urls";
import Select from 'react-select/creatable';
import classes from "./TruckMaster.module.css"
import Modal from '../../../Shared/PopupModal/PopupModal';
import TruckUploadExcel from "./TruckUploadExcel";
import { MastersChangeLog, findObjectDifferences, getCommonKeys, getProfileDetails } from "../../Utility";
import { toast } from "react-toastify";
import Loader from "../../../Loader/Loader";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import _ from "lodash";
import DownloadMastersButton from "../Utility/DownloadMastersButton";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import { isSuperUser } from "../FreightMaster/UploadExcel/Step1/utils";
import {EditableEmailsContext} from "../../../../Context/EditableEmailsContext"
import { sendMailToMasters } from "../Utility/utility";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";

/**
 * Component for viewing vehicle details
 * @param {Object} truckMaster - Truck master object containing vehicle details
 * @returns {JSX.Element} ViewVehicleDetails component
 */
const ViewVehicleDetails = ({truckMaster}) => {
    return (
        <div style={{ overflowY: "scroll", overflowX: 'hidden', wordWrap: 'break-word', maxHeight: "50vh" }}>
            {truckMaster && truckMaster.trucks && truckMaster.trucks.length > 0 ? 
                truckMaster.trucks.map((truck, index) => {
                    return (
                        <div className="row px-4" key={truck.vehicle_no}>
                            <div>{index + 1}.</div>
                            <div>{truck.vehicle_no}</div>
                        </div>
                    )
                })
            : <center>No truck details to show</center>
            }
        </div>
    )
}

/**
 * TruckMaster
 * Main component for truck master data
 * @returns {JSX.Element} TruckMaster component
 */
const TruckMaster = ({ canedit = true, canAccess, canUpdate, checkActionPermission }) => {
    const [truckMasterList, setTruckMasterList] = useState([])
    const [company_id, setCompanyId] = useState('')
    const [TruckCategory, setTruckCategory] = useState([])
    const [TruckNames, setTruckNames] = useState([])
    const [TruckUnit, setTruckUnit] = useState([])
    const [show, setShow] = useState(false)
    const {companyProfile} = useContext(UserApiContext)
    const {userDetails} = useContext(UserApiContext)
    const [deletion_list, setDeletion_list] = useState([])
    const {companySettingData} = useContext(MyCompanyProfileContext)
    const [selectedOrg, setSelectedOrg] = useState("company")
    const [orgList, setOrgList] = useState([])
    const [isOrgLevel, setIsOrgLevel] = useState(false)

    const emailData = useContext(EditableEmailsContext);

    const [superAdmins,setSuperAdmin] = useState([])
    const [emailTemplate,setEmailTemplate] = useState({
        from:'',
        content:'',
        subject:'',
        cc:[],
        description:''
    })
    const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);
    useEffect(()=>{
    if(emailData && emailData?.notifyEmailForMastersUpdate){
        setEmailTemplate({
        content:emailData?.notifyEmailForMastersUpdate?.content,
        subject: emailData?.notifyEmailForMastersUpdate?.subject,
        cc: emailData?.notifyEmailForMastersUpdate?.cc || "connect@logisticsnow.in",
        from:emailData?.notifyEmailForMastersUpdate?.from,
        description:emailData?.notifyEmailForMastersUpdate?.email_description
        })
    }
    },[emailData])
    
    useEffect(()=>{
        if(companySettingData && companySettingData?.contact_information && companySettingData?.contact_information?.length > 0){
        const superAdminEmails = companySettingData?.contact_information?.filter((t)=>t?.super_admin===true)?.map((m)=>{
            return {
            name:m?.name,
            email:m?.email
            }
        })
        if(superAdminEmails && superAdminEmails?.length > 0 ){
            setSuperAdmin(superAdminEmails)
        }else{
            setSuperAdmin([])
        }
        }else{
        setSuperAdmin([])
        }
    },[companySettingData])

    // useeffect for setting truck details and company id and user details 
    useEffect(() => {
        setShow(true)

        if (companyProfile && userDetails) {
            if (companyProfile.domain_data && companyProfile.domain_data.company_id) {
                const id = companyProfile.domain_data.company_id
                setCompanyId(id)
                getProfileDetails(id, 'truck_details', selectedOrg).then(res => {
                    setShow(false)
                    if (res.data && res.data[0].truck_details) {
                        setTruckMasterList(res.data[0].truck_details)
                    }
                }).catch(err => {
                    console.log(err)
                    setShow(false)
                })
            }
        }
        
        axios.get(`${Urls.Autocomplete.Get.getlist}?searchFields=truck`)
            .then(res => {
                setTruckNames(res.data.map(item => {
                        return { label: item.name, value: item.name }
                }))
            })
            .catch(err => {
                console.log(err)
            })
        setTruckUnit(truck_unit_options.map(item => {
                return { label: item.name, value: item.value }
        }))
        setTruckCategory(truck_category_options.map(item => {
                return { label: item.name, value: item.value }
        }))

    }, [companyProfile, userDetails,selectedOrg])

    const fetchMaterialCategories = async () => {
        try {
          const res = await axios.get(
            `${Urls.companyMaster}?master_type=material&company_id=${company_id}`
          );
          const materialData = res?.data?.master_details || [];
    
          if (materialData.length > 0) {
            const uniqueCategories = Array.from(
              new Set(
                materialData
                  .map((entry) => entry?.material_category)
                  .filter(Boolean)
              )
            );
            const options = uniqueCategories.map((category) => ({
              label: category,
              value: category,
            }));
    
            // ensure unique
            setTruckCategory((prev) => {
              const combined = [...prev, ...options];
    
              const unique = Array.from(
                new Map(combined.map((item) => [item.value, item])).values()
              );
    
              return unique;
            });
          }
        } catch (err) {
          console.log(err);
        }
    };

    useEffect(() => {  
      if (company_id && company_id !== "") {
          fetchMaterialCategories();
      }
    }, [company_id]);
      
    useEffect(()=>{
        if(companySettingData && companySettingData.contact_information){
            const result = isSuperUser(companySettingData.contact_information);
            if(result){
                if(result.organizationList && result.organizationList.length > 0){
                    setOrgList(result.organizationList)
                }
            }
        }
        if(companySettingData && companySettingData.masters_setting){
            if(companySettingData.masters_setting.masters_show_level && companySettingData.masters_setting.masters_show_level === "organization_level" ){
                setIsOrgLevel(true)
            }
        }
    },[companySettingData])
    
    // array for truck category options
    const truck_category_options = [
        {
            "name": "Ambient",
            "value": "Ambient"
        },
        {
            "name": "Reefer",
            "value": "Reefer"
        }
    ]

    // const truck_type_options = [
    //     {
    //         "name": "Cylindrical",
    //         "value": "Cylindrical"
    //     },
    //     {
    //         "name": "Container",
    //         "value": "Container"
    //     }
    // ]

    // Array for truck units
    const truck_unit_options = [
        {
            "name": "KG",
            "value": "KG"
        },
        {
            "name": "TON",
            "value": "TON"
        }
    ]
    
    const deleteLanes = (e) => {
        // check if lane is selected or not
        if(!deletion_list && deletion_list.length < 1){
            toast.error('Please Select atleast 1 item');
            return false;
        }

        // confirm delete
        if (window.confirm("Are you sure to delete?")) {
            TrackMixPanel({
                ModuleName: 'masters',
                ScreenName: 'truck master',
                Data: `user deleted ${deletion_list.length === truckMasterList.length &&  truckMasterList.length > 3 ? 'All Lanes' : `lanes with truck category: ${deletion_list.map((deletedLane) => deletedLane.truck_category)}, truck type : ${deletion_list.map((deletedLane) => deletedLane.truck_type)}`}`,
                Definition: 'user has clicked on truck master all lane delete button'
            });

            setShow(true)
            const payload = {
                "data": deletion_list
            }

            axios.post(`${Urls.companyProfile}?company_id=${companyProfile.domain_data.company_id}&truck_master=remove`, payload)
                .then(res => {
                    sendMailToMasters(
                        "Truck Master",
                        emailTemplate,
                        superAdmins,
                        {
                            action: `Multiple Item(s) Deleted`,
                            lane: '',
                        },
                        ()=>{},
                        userDetails?.user_name || userDetails?.email?.split("@")[0]
                    );
                    const updatedList = truckMasterList.filter(
                        (truck) => !deletion_list.some((deletedLane) => deletedLane === truck)
                    );
                    setTruckMasterList([...updatedList]);
                    setDeletion_list([]);
                    setShow(false);
                    toast.success("Lanes deleted successfully");
                })
                .catch((err) => {
                    console.error(err)
                    setShow(false)
                })
        }
    }

    /**
     * Component to handle input of new truck in truck master
     * @returns {JSX.Element} renders ui for input fields
     */
    const AddNewTruckMaster = () => {
        const [truck_category, setTruck_category] = useState('')
        const [truck_name, setTruck_name] = useState('')
        const [length, setLength] = useState();
        const [breadth, setBreadth] = useState();
        const [containerHeight, setContainerHeight] = useState();
        const [containerVolume, setContainerVolume] = useState();
        const [weight, setWeight] = useState();
        const [unit, setUnit] = useState();
        const [vehicleDetails, setVehicleDetails] = useState([])

        // useeffect to set default values
        useEffect(() => {
            if (containerHeight > 0 && length > 0 && breadth > 0) {
                const totalVolume = length * breadth * containerHeight;
                setContainerVolume(Number(totalVolume.toFixed(4)))
            }else{
                setContainerVolume(0);
            }
        }, [ containerHeight, length, breadth])

        /**
         * Function to handle volume changes
         * @param {Event} e - Event for volume change
         * @returns {void} does not return anything
         */
        const handleVolume = (e) => {
            setContainerVolume(e.target.value)
        }

        /**
         * Function to save truck details into master via api call 
         * @returns {void} does not return anything
         */
        const save_truck_details = () => {

            // sql injection checks
            // const sqlInjectionPatterns = /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))/i;
            const sqlInjectionPatterns = /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))|(insert\s+into\s+\w+\s*\([^)]*\)\s*values\s*\([^)]*\))/i;

            if(sqlInjectionPatterns.test(truck_category)){
                toast.error('Please add valid truck category')
            } else if(sqlInjectionPatterns.test(truck_name)){
                toast.error('Please add valid truck name')
            } else if(!truck_category || truck_category === ''){
                toast.error('Please select truck category')
            } else if(!truck_name || truck_name === ''){
                toast.error('Please select truck type')
            } else if(!length || length === '' || !breadth || breadth === '' || !containerHeight || containerHeight === ''){
                toast.error('Please add all dimensions')
            } else if(!weight || weight === ''){
                toast.error('Please add weight')
            } else if(!unit || unit === ''){
                toast.error('Please add unit')
            }
            else {
                // if (truck_type === 'Container') {
                //     dimension = {
                //         length: length,
                //         breadth: breadth,
                //         height: containerHeight,
                //         volume: containerVolume
                //     }
                // } else {
                //     dimension = {
                //         radius: radius,
                //         height: height,
                //         volume: volume
                //     }
                // }
                // Prepare payload 
                const dimension = {
                    length: length,
                    breadth: breadth,
                    height: containerHeight,
                    volume: containerVolume
                }
                const truckMaster = {
                    truck_category: truck_category,
                    truck_type: truck_name,
                    truck_name: truck_name,
                    dimensions: dimension,
                    weight: weight,
                    unit: unit,
                    no_of_trucks: vehicleDetails.length,
                    trucks: vehicleDetails,
                    organization_id: selectedOrg === "company" ? undefined : selectedOrg
                }

                TrackMixPanel({
                  ModuleName: 'masters',
                  ScreenName: 'truck master',
                  Data: `truck category:${truck_category ?truck_category : 'none'}, Truck type : ${truck_name ? truck_name : 'none'}, Length :${length ? length : 'none'}, Breadth :${breadth ? breadth : 'none'}, Height: ${containerHeight? containerHeight : 'none'}, Volume: ${containerVolume ? containerVolume : 'none'}, Weight: ${weight ? weight : 'none'}, Unit: ${unit ? unit : 'none'}`,
                  Definition: 'user has clicked on add details truck master button'
                });

                axios.post(`${Urls.companyProfile}?company_id=${company_id}&truck_master=add`,
                    {
                      data: [truckMaster]
                    }
                  )
                  .then(
                    (res) => 
                        {
                        setTruckMasterList(res.data[0].truck_details),
                        sendMailToMasters("Truck Master",emailTemplate,superAdmins,{
                            action:"New Truck Added",
                            lane:truckMaster
                        }
                        , () => {},userDetails?.user_name || userDetails?.email?.split("@")[0])
                        toast.success("Data Added Successfully")
                        if (document.getElementById("close_addTruckMaster")) {
                            document.getElementById("close_addTruckMaster").click();
                        }
                        }
                  ).catch(err =>{
                    console.error(err,'error')
                  })
                // }else{
                    // axios.post(`${Urls.companyProfile}?company_id=${company_id}&organization_id=${selectedOrg}&truck_master=add`,
                        // {
                        //   data: [truckMaster]
                        // }
                    //   )
                    //   .then(
                    //     (res) => setTruckMasterList(res.data[0].truck_details),
                    //     toast.success("Data Added Successfully")
                    //   ).catch(err =>{
                    //     console.error(err,'error')
                    //   })
                // }
  }
        }

        /**
         * VehicleDetails
         * Component for managing vehicle details
         * @param {Array<Object>} vehicleDetails - Array of vehicle details
         * @param {React.SetStateAction} setVehicleDetails - set vehicle details
         * @returns {JSX.Element}  renders VehicleDetails component
         */
        const VehicleDetails = ({ vehicleDetails, setVehicleDetails }) => {
            const [vehicle_number, setVehicle_number] = useState('')

            /**
             * Adds a new vehicle to the vehicle details list
             */
            const handleAddRow = () => {
                setVehicleDetails((prevData) => [
                    ...prevData,
                    {
                        vehicle_no: vehicle_number,
                        allocated: false
                    },
                ]);
                setVehicle_number("")
            };

            /**
             * Removes a vehicle from the vehicle details list
             * @param {number} index - Index of the vehicle to remove
             */
            const handleRemove = (index) => {
                const temp = vehicleDetails.filter((vehicle, idx) => idx !== index)
                setVehicleDetails(temp)
            };

            return (
                <div>
                    <div>
                        <div className="row align-items-center">
                            <div className="col-md-8">
                                <label>Add vehicle number</label>
                                <input type="text" onChange={e => setVehicle_number(e.target.value)} />
                            </div>
                            <div className="col-md-4">
                                <button className="btn btn-primary btn-sm px-4 mt-1" onClick={handleAddRow} disabled={vehicle_number === "" ? true : false}>Add</button>
                            </div>
                        </div>
                        <div style={{ overflowY: "scroll", overflowX: 'hidden', wordWrap: 'break-word', maxHeight: "50vh"}}>
                            {vehicleDetails && vehicleDetails.length > 0 ?
                                vehicleDetails.map((vehicle, index) => (
                                    <div key={index} className="row p-4">
                                        <div className="col-md-2">{index + 1}.</div>
                                        <div className="col-md-4" style={{wordWrap: 'break-word'}}>{vehicle.vehicle_no}</div>
                                        <div className="col-md-4">
                                            <button className={`btn btn-secondary btn-sm text-end`} style={{color: 'white', cursor: 'pointer', fontWeight: 'bolder' }} onClick={() => handleRemove(index)}>
                                                <i className="fa fa-trash-o" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                ))
                                : null
                            }
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div>
                {/* <Loader show={show} /> */}
                <div style={{position:"absolute", marginTop:"-48px",marginBottom:"25px", right:"10%"}}>
                {isOrgLevel === true && 
                <select
                    className="form-control mr-2"
                    style={{maxWidth:"max-content"}}
                    value={selectedOrg}
                    onChange={(e) => setSelectedOrg(e.target.value)}
                    >
                    <option value={"company"} selected>Company</option>
                    {
                        orgList && orgList.length > 0 &&
                        orgList.map(item =>{
                        return (
                            <option value={item.id} key={item.id} >{item.name}</option>
                        )
                        }) 
                    }
                </select>}
                </div>
                <div className={`row m-0 mb-3 mt-2`}>
                    <div className={'col-md-6 pr-2'}>
                        <span style={{ fontWeight: '600', fontSize: '13px', whiteSpace: 'nowrap' }}>Truck Category <span className="required-field"> *</span></span>
                        <label style={{ width: '100%', pointerEvents: (canedit || !canUpdate) ? 'none' : 'auto', marginBottom: 0 }}>
                            <Select
                                options={TruckCategory}
                                isMulti={false}
                                onChange={e => setTruck_category(e.value)}
                                className={"Truck_Type_Select"}
                                classNamePrefix={"Truck_Prefix"}
                                defaultValue=""
                                isDisabled={canedit || !canUpdate}
                            />
                        </label>
                    </div>
                    <div className={'col-md-6 pl-2'}>
                        <span style={{ fontWeight: '600', fontSize: '13px', whiteSpace: 'nowrap' }}>Truck Type <span className="required-field"> *</span></span>
                        <label style={{ width: '100%', pointerEvents: (canedit || !canUpdate) ? 'none' : 'auto', marginBottom: 0 }}>
                            <Select
                                options={TruckNames}
                                isMulti={false}
                                onChange={e => setTruck_name(e.value)}
                                className={"Truck_Type_Select"}
                                classNamePrefix={"Truck_Prefix"}
                                defaultValue=""
                                isDisabled={canedit || !canUpdate}
                            />
                        </label>
                    </div>
                </div>
                <div className={`row m-0 mb-3`}>
                    <div className={'col-md-4 pr-2'}>
                        <span style={{ fontWeight: '600', fontSize: '13px', whiteSpace: 'nowrap' }}>Length (ft)<span className="required-field">*</span></span>
                        <label style={{ width: '100%', marginBottom: 0 }}>
                            <input className="form-control" type="number" style={{ height: '37px', padding: '0 8px' }} onChange={e => setLength(Number(e.target.value))} disabled={canedit || !canUpdate} />
                        </label>
                    </div>
                    <div className={'col-md-4 px-2'}>
                        <span style={{ fontWeight: '600', fontSize: '13px', whiteSpace: 'nowrap' }}>Breadth (ft)<span className="required-field">*</span></span>
                        <label style={{ width: '100%', marginBottom: 0 }}>
                            <input className="form-control" type="number" style={{ height: '37px', padding: '0 8px' }} onChange={e => setBreadth(Number(e.target.value))} disabled={canedit || !canUpdate} />
                        </label>
                    </div>
                    <div className={'col-md-4 pl-2'}>
                        <span style={{ fontWeight: '600', fontSize: '13px', whiteSpace: 'nowrap' }}>Height (ft)<span className="required-field">*</span></span>
                        <label style={{ width: '100%', marginBottom: 0 }}>
                            <input className="form-control" type="number" style={{ height: '37px', padding: '0 8px' }} onChange={e => setContainerHeight(Number(e.target.value))} disabled={canedit || !canUpdate} />
                        </label>
                    </div>
                </div>
                <div className={`row m-0 mb-3`}>
                    <div className={'col-md-4 pr-2'}>
                        <span style={{ fontWeight: '600', fontSize: '13px', whiteSpace: 'nowrap' }}>Volume (ft³)<span className="required-field">*</span></span>
                        <label style={{ width: '100%', marginBottom: 0 }}>
                            <input className="form-control" type="number" style={{ height: '37px', padding: '0 8px' }} value={containerVolume === 0 ? '' : containerVolume} onChange={handleVolume} placeholder="" disabled={canedit || !canUpdate} />
                        </label>
                    </div>
                    <div className={'col-md-4 px-2'}>
                        <span style={{ fontWeight: '600', fontSize: '13px', whiteSpace: 'nowrap' }}>Weight <span className="required-field"> *</span></span>
                        <label style={{ width: '100%', marginBottom: 0 }}>
                            <input className="form-control" type="number" onChange={e => setWeight(Number(e.target.value))} value={weight} style={{ width: '100%', height: '38px', padding: '0 8px' }} disabled={canedit || !canUpdate} />
                        </label>
                    </div>
                    <div className={'col-md-4 pl-2'}>
                        <span style={{ fontWeight: '600', fontSize: '13px', whiteSpace: 'nowrap' }}>Unit <span className="required-field"> *</span></span>
                        <label style={{ width: '100%', marginBottom: 0, pointerEvents: (canedit || !canUpdate) ? 'none' : 'auto' }}>
                            <Select
                                options={TruckUnit}
                                isMulti={false}
                                onChange={e => setUnit(e.value)}
                                className={"Truck_Type_Select"}
                                classNamePrefix={"Truck_Prefix"}
                                defaultValue=""
                                isSearchable={false}
                                isDisabled={canedit || !canUpdate}
                            />
                        </label>
                    </div>
                </div>
                <div className="row m-0 justify-content-center mt-5 mb-4 align-items-center">
                    <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                        <Modal
                            buttonLabel={`Add Vehicle Details`}
                            buttonClass="btn btn-link px-0"
                            style={{ padding: 0 }}
                            disabled={canedit || !canUpdate}
                            content={<VehicleDetails vehicleDetails={vehicleDetails} setVehicleDetails={setVehicleDetails} />}
                            title={`Vehicle Details`}
                            id="closebutton"
                            screenName="Truck Master"
                            moduleName="Truck Master"
                            activityName="Truck Master - View Truck button clicked"
                            backdrop={true}
                            closeButtonId="close_contactus1"
                        />
                        <button className="btn btn-success px-4" disabled={canedit || !canUpdate} onClick={() => save_truck_details()}>
                            Add Truck Details
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Edit truck master item
     * @param {any} truckMaster - all truck master data 
     * @param {any} index - index of edit
     * @param {any} userDetails - user details
     * @returns {void} does not return anything
     */
    const EditTruckMaster = ({sendMailToMasters, superAdmins, emailTemplate,truckMaster, index, userDetails }) => {
        const [truckCategory, settruckCategory] = useState('')
        const [truckType, setTruckType] = useState('')
        const [weight, setWeight] = useState ()
        const [unit, setUnit] = useState()
        const [length, setLength] = useState ()
        const [breadth, setBreadth] = useState()
        const [height, setHeight] = useState ()
        const [volume, setVolume] = useState ()
        const [prevData, setPrevData] = useState({})
        const [vehicle_number, setVehicle_number] = useState('')
        const [vehicleDetails, setVehicleDetails] = useState([])

        // useeffect for setting default vehicle details
        useEffect(()=>{
            // setVolume(truckMaster.dimensions.volume)
            var temp = _.cloneDeep(truckMaster)
            setPrevData(temp)
            setHeight(truckMaster.dimensions.height)    
            setLength(truckMaster.dimensions.length)
            setBreadth(truckMaster.dimensions.breadth)
            setVehicleDetails(truckMaster.trucks ? truckMaster.trucks : [])
        },[truckMaster])

        // useeffect for setting volume details
        useEffect(()=>{
            if (height > 0 && length > 0 && breadth > 0) {
                const totalVolume = length * breadth * height;
                setVolume(Number(totalVolume.toFixed(4)))
            }else{
                setVolume(0)
            }
        },[height, length, breadth])
        
        /**
         * Function to save edited trucks
         * @param {Array<Object>} truckMaster - all trucks
         * @returns {void} does not return anything
         */
        const handleEditSave = (truckMaster) => {
             // validations 
            const sqlInjectionPatterns = /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))|(insert\s+into\s+\w+\s*\([^)]*\)\s*values\s*\([^)]*\))/i;

            if(sqlInjectionPatterns.test(truckCategory)){
                toast.error('Please add valid truck category')
            } else if(sqlInjectionPatterns.test(truckType)){
                toast.error('Please add valid truck type')
            }
            else{
                 // payload
                const dimension = {
                    length: length && length !== undefined? length : truckMaster.dimensions.length,
                    breadth: breadth && breadth !== undefined? breadth : truckMaster.dimensions.breadth,
                    height: height && height !== undefined? height : truckMaster.dimensions.height,
                    volume: volume && volume !== undefined? volume : truckMaster.dimensions.volume,
                }
                const truckMaster2 = {
                    truck_category: truckCategory && truckCategory !== undefined? truckCategory : truckMaster.truck_category,
                    truck_type: truckType && truckType !== undefined? truckType : truckMaster.truck_type,
                    truck_name: truckType && truckType !== undefined? truckType : truckMaster.truck_type,
                    dimensions: dimension,
                    weight: weight && weight !== undefined? weight : truckMaster.weight,
                    unit: unit && unit !== undefined? unit : truckMaster.unit,
                    truckid: truckMaster.truckid,
                    no_of_trucks: vehicleDetails.length,
                    trucks: vehicleDetails ? vehicleDetails : []
                }
                const updated_data = findObjectDifferences(prevData, truckMaster2)
                const previous_data = getCommonKeys(prevData, updated_data)

                TrackMixPanel({
                  ModuleName: 'masters',
                  ScreenName: 'truck master',
                  Data: `edited truck category:${truckMaster?.truck_category ? truckMaster.truck_category : 'none'}, Truck type : ${truckMaster?.truck_type ? truckMaster.truck_type : 'none'}, Length :${dimension?.length ? dimension.length : 'none'}, Breadth :${dimension?.breadth ? dimension.breadth : 'none'}, Height: ${dimension?.height ? dimension.height : 'none'}, Volume: ${dimension?.volume ? dimension.volume : 'none'}, Weight: ${truckMaster?.weight ? truckMaster.weight: 'none'}, Unit: ${truckMaster?.unit ? truckMaster.unit : 'none'}`,
                  Definition: 'user has clicked on truck master save button'
                });
                axios.post(`${Urls.companyProfile}?company_id=${company_id}&truck_master=edit`, { data: [truckMaster2] })
                .then((res) =>
                {
                    sendMailToMasters("Truck Master",emailTemplate,superAdmins,{
                    action:"Truck Edited",
                    lane:truckMaster
                    }
                    ,setShow,userDetails?.user_name || userDetails?.email?.split("@")[0])
                    setTruckMasterList(res.data[0].truck_details)
                }
                )
                .catch((error) => {
                    console.log(error)
                })

                const activity = {
                    "truck_type": truckMaster.truck_type,
                    "existing_data": previous_data,
                    "updated_data": updated_data,
                }
                MastersChangeLog("Line Item Updated", "truck_master", userDetails.email, userDetails.user_id, company_id, activity)
                document.getElementById("close_contactus1").click();
                toast.success('Details Edited Successfully')
                }
            }

        /**
         * function to add new row for vehicle details
         */
        const handleAddRow = () => {
            setVehicleDetails((prevData) => [
                ...prevData,
                {
                    vehicle_no: vehicle_number,
                    allocated: false
                },
            ]);
            setVehicle_number("")
        };

        /**
         * Function to delete row of vehicle details
         */
        const handleRemove = (index) => {
            const temp = vehicleDetails.filter((vehicle, idx) => idx !== index)
            setVehicleDetails(temp)
        };

        return (
            <>
                <div className={`row m-0`}>
                    <div className={'col-md-3'}>
                        <span style={{ fontWeight: '600' }}>Truck Category</span>
                        <label style={{ width: '100%' }}>
                            <Select
                                options={TruckCategory}
                                isMulti={false}
                                onChange={e => {
                                    settruckCategory(e.value)
                                }}
                                // value={truck_category}
                                className={"Truck_Type_Select"}
                                classNamePrefix={"Truck_Prefix"}
                                defaultValue={truckCategory}
                                placeholder={truckMaster.truck_category ? truckMaster.truck_category : 'Select..'}
                                isSearchable={false}
                            />
                        </label>
                    </div>
                    <div className={'col-md-3'}>
                        <span style={{ fontWeight: '600' }}>Truck Type</span>
                        <label style={{ width: '100%' }}>
                            <Select
                                options={TruckNames}
                                isMulti={false}
                                onChange={e => {
                                    setTruckType(e.value)
                                }}
                                // value={truck_name}
                                className={"Truck_Type_Select"}
                                classNamePrefix={"Truck_Prefix"}
                                defaultValue={truckMaster.truck_type}
                                placeholder={
                                    truckMaster.truck_type
                                      ? truckMaster.truck_type.length > 10
                                        ? truckMaster.truck_type.slice(0, 10) + '...'
                                        : truckMaster.truck_type
                                      : 'Select..'
                                  }
                            />
                        </label>
                    </div>
                    <div className={'col-md-3'}>
                        <span style={{ fontWeight: '600' }}>Weight</span>
                        <label style={{ width: '100%' }}>
                            <input type="number" onChange={e => {
                                setWeight(Number(e.target.value))
                            }}
                                // value={weight}
                                defaultValue={truckMaster.weight}
                                style={{ width: '100%', height: '38px', borderRadius: '5px' }} />
                        </label>
                    </div>
                    <div className={'col-md-3'}>
                        <span style={{ fontWeight: '600' }}>Unit</span>
                        <label style={{ width: '100%' }}>
                            <Select
                                options={TruckUnit}
                                isMulti={false}
                                onChange={e => { setUnit(e.value) }}
                                // value={unit}
                                className={"Truck_Type_Select"}
                                classNamePrefix={"Truck_Prefix"}
                                defaultValue={truckMaster.unit}
                                placeholder={truckMaster.unit ? truckMaster.unit : 'Select..'}
                                isSearchable={false}
                            />
                        </label>
                    </div>
                </div>
                <div className={`row m-0 mb-5`}>
                    <div className={'col-md-3'}>
                        <span style={{ fontWeight: '600' }}>Length (ft)</span>
                        <label style={{ width: '100%' }}>
                            <input type="number" style={{ height: '37px' }} onChange={e => { setLength(Number(e.target.value)) }} defaultValue={length}  />
                        </label>
                    </div>
                    <div className={'col-md-3'}>
                        <span style={{ fontWeight: '600' }}>Breadth (ft)</span>
                        <label style={{ width: '100%' }}>
                            <input type="number" style={{ height: '37px' }} onChange={e => { setBreadth(Number(e.target.value)) }} defaultValue={breadth} />
                        </label>
                    </div>
                    <div className={'col-md-3'}>
                        <span style={{ fontWeight: '600' }}>Height (ft)</span>
                        <label style={{ width: '100%' }}>
                            <input type="number" style={{ height: '37px' }} onChange={e => { setHeight(Number(e.target.value)) }} defaultValue={height} />
                        </label>
                    </div>
                    <div className={'col-md-3'}>
                        <span style={{ fontWeight: '600' }}>Volume (ft³)</span>
                        <label style={{ width: '100%' }}>
                            <input 
                                type="number"  
                                style={{ height: '37px'}} 
                                defaultValue={volume}
                                placeholder=""
                                onChange={e => { setVolume (Number(e.target.value)) }} 
                            />
                        </label>
                    </div>
                    <div className={'col-md-6'}>
                        <span style={{ fontWeight: '600' }}>Vehicle Details</span>
                        <label className="row px-4">
                            <input type="text" className="col-md-7" onChange={e => setVehicle_number(e.target.value)} />
                            <button className="btn btn-primary btn-sm px-2 col-md-2 ml-2" style={{height: '30px'}}
                            onClick={handleAddRow} 
                            disabled={vehicle_number === "" ? true : false}>Add</button>
                        </label>
                    </div>
                </div>
                <div className="px-4" style={{ marginTop: '-6%' ,overflowY: "scroll", overflowX: 'hidden', wordWrap: 'break-word', maxHeight: "15vh" }}>
                    {vehicleDetails && vehicleDetails.length > 0 ?
                        vehicleDetails.map((vehicle, index) => {
                            return (
                                <div key={index} className="row px-4 mt-2">
                                    <div className="">{index + 1}.</div>
                                    <div className="mx-2" style={{ wordWrap: 'break-word' }}>{vehicle.vehicle_no}</div>
                                    <div className="col-md-4">
                                        <button className={`btn btn-light btn-sm text-end`} style={{ cursor: 'pointer', fontWeight: 'bolder' }} onClick={() => handleRemove(index)}>
                                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            )
                        })
                        : null
                    }
                    </div>
                <div className={`text-center`}>
                    <button className={`${classes['save-btn']} btn btn-success`}
                        onClick={() => handleEditSave(truckMaster)}
                    >Save</button>
                </div>
            </>
        )
    }

    /**
     * Handles deletion of a truck master entry
     * @param {Event} e - event object
     * @param {Object} item - truck master item to delete
     */
    const deleteHandler = (e, item) => {
        if (window.confirm("Are you sure to cancel?")) {
            TrackMixPanel({
              ModuleName: 'masters',
              ScreenName: 'truckmaster',
              Data: `user deleted truck category:${item?.truck_category ? item.truck_category : 'none'}, Truck type : ${item?.truck_type ? item.truck_type : 'none'}, Length :${item?.dimensions.length ? item.dimensions.length : 'none'}, Breadth :${item?.dimensions.breadth ? item.dimensions.breadth : 'none'}, Height: ${item?.dimensions.height ? item.dimensions.height : 'none'}, Volume: ${item?.dimensions.volume ? item.dimensions.volume : 'none'}, Weight: ${item?.weight ? item.weight : 'none'}, Unit: ${item?.unit ? item.unit : 'none'}`,
              Definition: 'user has clicked on truck master delete button'
            });
            let finalUrl = ""
            if(selectedOrg === 'company'  || !selectedOrg || selectedOrg === undefined){
                finalUrl = `${Urls.companyProfile}?company_id=${company_id}&truck_master=remove`
            }else{
                finalUrl = `${Urls.companyProfile}?company_id=${company_id}&organization_id=${selectedOrg}&truck_master=remove`
            }
            // API call
            axios
              .post(
                finalUrl,
                {
                  data: [item],
                }
              )
              .then(
                (res) =>
                {
                    sendMailToMasters("Truck Master",emailTemplate,superAdmins,{
                    action:"Truck Deleted",
                    lane:item
                    }
                    ,setShow,userDetails?.user_name || userDetails?.email?.split("@")[0])
                    setTruckMasterList(res.data[0].truck_details)
                    toast.success("Deleted successfully")
                }
              );
            const activity = [{
                "truck_name": item.truck_type,
            }]
            MastersChangeLog("Line Item Deleted", "truck_master", userDetails.email, userDetails.user_id, company_id, activity)
        }
    }

    /**
     * Handles selection/deselection of all truck master entries
     * @param {Event} e - event object for select button
     */
    const selectAllHandler = (e) => {
        if(e.target.checked){ 
            let list = deletion_list.slice()
            if(truckMasterList && truckMasterList.length > 0){
                truckMasterList.map(item =>{
                    if(!deletion_list.includes(item)){
                        list.push(item)
                    }
                })
                setDeletion_list(list)
            }
        } else { 
            setDeletion_list([])
        }
    }

    /**
     * Handles single checkbox selection for truck master entries
     * @param {Event} e - event object
     * @param {Object} item - truck master item of with the checkbox
     */
    const checkboxeshandler = (e, item) => {
        if(e.target.checked){
            let list = deletion_list.slice()
            list.push(item)
            setDeletion_list(list)
        } else{ 
            let temp = deletion_list.filter(value => {
                return value
            })
            setDeletion_list(temp)
        }
    }

    return (
        <div className="pr-5 mt-3 my-3">
            <div className={`d-flex align-items-center justify-content-between px-2`} style={{ marginBottom: '15px' }}>
                <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                    <Modal
                        buttonLabel={
                            <>
                                <i className="fa fa-plus pr-2" />
                                Add Truck Master
                            </>
                        }
                        buttonClass="btn btn-primary"
                        style={{ fontSize: '12px', backgroundColor: '#3f51b5', borderColor: '#3f51b5' }}
                        disabled={canedit || !canUpdate}
                        content={<AddNewTruckMaster />}
                        title={`Add Truck Master`}
                        id="addTruckMasterModal"
                        closeButtonId="close_addTruckMaster"
                        screenName="Truck Master"
                        moduleName="Truck Master"
                        activityName="Truck Master - Add Truck button clicked"
                        backdrop={"static"}
                        size="xl"
                    />
                    <Modal
                        buttonLabel={
                            <>
                                <i className="fa fa-upload pr-2" />
                                Upload Files
                            </>
                        }
                        buttonClass="btn btn-primary"
                        style={{ fontSize: '12px', backgroundColor: '#3f51b5', borderColor: '#3f51b5' }}
                        disabled={canedit || !canUpdate}
                        content={<TruckUploadExcel superAdmins={superAdmins} emailTemplate={emailTemplate} truckMasterList={truckMasterList} setTruckMasterList={setTruckMasterList} companyId={company_id} />}
                        title={`Truck Master`}
                        id="closebutton"
                        screenName="Company Profile"
                        moduleName="Truck Master"
                        activityName="Truck Master - Upload excel"
                        closeButtonId="close_contactus1"
                    />
                    <button
                        id="submitLane"
                        style={{ fontSize: '12px', backgroundColor: '#f5939a', color: 'white', border: 'none' }}
                        disabled={deletion_list.length === 0 || canedit || !canUpdate}
                        className="btn btn-sm btn-danger"
                        onClick={(e) => deleteLanes(e)}
                    >
                        Delete
                    </button>
                    <DownloadMastersButton
                        type={"truck"}
                        company_id={company_id}
                        masterList={truckMasterList}
                    />
                </div>
            </div>
            <div className={`${classes['table-alignment']} mr-3 `}>
            <div className={`position-absolute w-100 ${show ? "h-50" : ""}`}>
                <Loader show={show} />
            </div>
            <table className={`${classes['table-width']} table table-borderless`}>
                <thead>
                    <tr style={{ fontSize: "14px"}}>
                        <th className={`${classes['sticky-th']} pl-4`}>
                            <input 
                                type='checkbox'
                                checked={truckMasterList && truckMasterList.length > 0 && deletion_list.length === truckMasterList.length}
                                onChange={selectAllHandler} 
                                style={{width:'15px', height:'15px'}} />
                        </th>
                        <th scope="col" className={`${classes['sticky-th']}`} style={{ textAlign: "center" }}>Sr No.</th>
                        <th scope='col' className={`${classes['sticky-th']}`} style={{ textAlign: "center" }}>Truck Category</th>
                        <th scope="col" className={`${classes['sticky-th']}`} style={{ textAlign: "center" }}>Truck Type</th>
                        {/* <th scope="col" style={{ textAlign: "center" }}>Truck Type</th> */}
                        <th scope="col" className={`${classes['sticky-th']}`} style={{ textAlign: "center" }}>Dimensions</th>
                        <th scope="col" className={`${classes['sticky-th']}`} style={{ textAlign: "center" }}>Volume</th>
                        <th scope="col" className={`${classes['sticky-th']}`} style={{ textAlign: "center" }}>Weight</th>
                        <th scope="col" className={`${classes['sticky-th']}`} style={{ textAlign: "center" }}>Unit</th>
                        <th scope="col" className={`${classes['sticky-th']}`} style={{ textAlign: "center" }}>Vehicle Details</th>
                        <th scope="col" className={`${classes['sticky-th']}`} style={{ textAlign: "center" }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {truckMasterList && truckMasterList.length > 0 ?
                        truckMasterList.map((truckMaster, index) => {
                            return <tr key={`${truckMaster.truck_type}_${index}`}>
                                <td className={classes['borderforTd']}>
                                    <input type="checkbox" style={{ width: '15px', height: '15px' }}
                                        onChange={e => checkboxeshandler(e, truckMaster)} checked={deletion_list.includes(truckMaster)}
                                    />
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {index + 1}.
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {truckMaster.truck_category}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {truckMaster.truck_type}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {truckMaster.dimensions.length && truckMaster.dimensions.breadth && truckMaster.dimensions.height ? <div>{`length-${truckMaster.dimensions.length} breadth-${truckMaster.dimensions.breadth} height-${truckMaster.dimensions.height}`}</div>
                                        : null}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {truckMaster && truckMaster.dimensions && truckMaster.dimensions.volume ? parseFloat(truckMaster.dimensions.volume).toFixed(2) : 0}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {truckMaster.weight}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {truckMaster.unit}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                    {truckMaster?.trucks?.length > 0 ? <Modal
                                        buttonLabel={`View`}
                                        buttonClass="btn btn-link"
                                        content={<ViewVehicleDetails truckMaster={truckMaster} />}
                                        title={`View Vehicle Details`}
                                        id="truckmaster"
                                        size="md"
                                        screenName="Truck master"
                                        moduleName="Truck master"
                                        closeButtonId="close_contactus1"
                                    /> : "-"}
                                </td>
                                <td className="text-center">
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <Modal
                                                buttonLabel={<i className="fa fa-pencil" />}
                                                buttonClass={`btn btn-link text-dark`}
                                                style={{}}
                                                disabled={canedit || !canUpdate}
                                                content={<EditTruckMaster sendMailToMasters={sendMailToMasters} superAdmins={superAdmins} emailTemplate={emailTemplate} truckMaster={truckMaster} index={index} userDetails={userDetails} />}
                                                title={`Edit Truck Master`}
                                                id="truckmaster"
                                                closeButtonId="close_contactus1"
                                                screenName="Truck Master"
                                                moduleName="Truck Master"
                                            />
                                        <button
                                            className="btn btn-link text-dark ml-3"
                                            onClick={(e) => {
                                                if (canedit || !canUpdate) {
                                                    checkActionPermission('update');
                                                } else {
                                                    deleteHandler(e, truckMaster);
                                                }
                                            }}
                                            style={{
                                                cursor: (canedit || !canUpdate) ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            <i className={`fa fa-trash`} aria-hidden="true" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        })
                        : null}
                </tbody>
            </table>
            </div>
        </div>
    )
}

export default TruckMaster;